import { render, staticRenderFns } from "./MarksTabs.vue?vue&type=template&id=7f1a3800"
import script from "./MarksTabs.vue?vue&type=script&lang=js"
export * from "./MarksTabs.vue?vue&type=script&lang=js"
import style0 from "./MarksTabs.vue?vue&type=style&index=0&id=7f1a3800&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports